/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/order-item-logs';

export const OrderItemLogApi = {
  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
